<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>

  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">identifier</th>
                <th class="table-heading-text text-right">valuation</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="vehicle in vehicles.vehicles" :key="vehicle.id" @click="showEditModal(vehicle )">
                <td class="table-content-text text-left"> {{ vehicle.identifier }}</td>
                <td class="table-content-text text-right">{{ vehicle.valuation.toLocaleString() }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td class="table-heading-text text-right">{{ Number(vehicles.total_valuation).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <!-- Modals-->
  <VehicleModalPopup :show="showModal" @close="showModal = false"></VehicleModalPopup> <!-- add a new record -->
  <VehicleEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></VehicleEditModalPopup> <!--edit a record -->

</template>

<script>
import axios from 'axios';
import VehicleModalPopup from './modals/VehicleNewModalPopup.vue';
import VehicleEditModalPopup from './modals/VehicleEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    VehicleModalPopup,
    VehicleEditModalPopup
  },
  data() { 
    return {
      vehicles: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getVehicles();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'vehicle assets',
          disabled: true,
          href: ''
        },
      ];
    },

  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow=row;
     this.showEditModalToggle = true;
    },
    async getVehicles(){
      try {
      const response  = await axios.get("/vehicles/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.vehicles = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load vehicles' });
      }
    }
  }
};
</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}


</style>